import React from 'react'
import { PopupButton } from 'react-calendly';
import { trackEvent } from '../../../helpers/mixpanel';
import { ScrollFadeIn } from '../../../components/ScrollFadeIn';
import Container from '../components/Container';
import GetStartedButton from '../components/GetStartedButton';


 const eric =
        "https://res.cloudinary.com/abundo-wealth-assets/image/upload/v1658176052/Abundo%20Wealth%20Assets/abundo-team/eric%20simonson/eric_1_ax79dw_lxm6lm.webp";
const EndCTA = () => {
   
  return (
      <Container bgColor="bg-white">
          <ScrollFadeIn className="flex flex-col lg:flex-row justify-evenly items-center lg:space-x-16  z-10">
              <div className="flex flex-col items-center ">
                  <img
                      loading="lazy"
                      src={eric}
                      alt="Eric Simonson of Abundo"
                      className="object-cover h-48  sm:h-64 lg:h-80 rounded-xl shadow-xl aspect-[8/7]"
                  />
                  <h1 className=" heading-2 text-gray-800 text-center mt-4">
                      Eric Simonson,
                  </h1>
                  <p className='body-1 text-gray-600 text-center'>Founder & CEO</p>
              </div>
              <div className="flex flex-col justify-start items space-y-5 max-w-4xl mt-10 lg:mt-0 z-10">

                  <h1 className="heading-1 sm:mb-">P.S. Here's the deal...</h1>
                  <div className="max-w-xl space-y-5">
                      <h5 className='font-lato text-xl font-bold   text-secondary-500'>
                          In case you're like me and just happened to skip to the end, here's
                          what we're offering you...
                      </h5>
                      <h5 className="body-1 text-gray-600">
                          Abundo is a trusted partner you can talk to about you, your
                          financial life, and your goals.
                      </h5>
                      <h5 className='body-1 text-gray-600'>
                          We don’t charge you
                          outrageous fees, and we will add clarity to your financial picture.
                      </h5>
                      <h5 className='body-1 text-gray-600'>
                          If we’re a good fit and you see the value of our advice and how much
                          money we can save you over your lifetime, we would love to work
                          together.
                      </h5>
                  </div>
                  <div className="">
                      {" "}
                   <GetStartedButton id='home-page-end-cta' />
                  </div>
              </div>
          </ScrollFadeIn>
      </Container>  )
}

export default EndCTA